import { directorySourceCatalogDTOSchema, directorySyncConnectStartDTOSchema, directorySyncNowResultDTOSchema, directorySyncRunDetailDTOSchema, directorySyncRunSummaryDTOSchema, directorySyncScimTokenDTOSchema, directorySyncStatusDTOSchema, personDTOSchema, } from '@instanexus/contracts';
import { z } from 'zod';
import { dataEnvelopeSchema, listEnvelopeSchema, WEB_API_PREFIX } from '../transport.js';
const BASE = `${WEB_API_PREFIX}/tenant/directory-sync`;
const statusSchema = dataEnvelopeSchema(directorySyncStatusDTOSchema);
const connectSchema = dataEnvelopeSchema(directorySyncConnectStartDTOSchema);
const catalogSchema = dataEnvelopeSchema(directorySourceCatalogDTOSchema);
const detailSchema = dataEnvelopeSchema(directorySyncRunDetailDTOSchema);
const personSchema = dataEnvelopeSchema(personDTOSchema);
const syncNowSchema = dataEnvelopeSchema(directorySyncNowResultDTOSchema);
const scimTokenSchema = dataEnvelopeSchema(directorySyncScimTokenDTOSchema);
const runsSchema = listEnvelopeSchema(directorySyncRunSummaryDTOSchema);
export function createDirectorySyncResource(transport) {
    return {
        async status() {
            return (await transport.request({ path: BASE, schema: statusSchema })).data;
        },
        async connect(provider) {
            return (await transport.request({ method: 'POST', path: `${BASE}/${encodeURIComponent(provider)}/connect`, schema: connectSchema })).data;
        },
        async complete(provider, input) {
            return (await transport.request({
                method: 'POST',
                path: `${BASE}/${encodeURIComponent(provider)}/complete`,
                body: input,
                schema: statusSchema,
            })).data;
        },
        async disconnect() {
            await transport.request({ method: 'DELETE', path: BASE, schema: z.undefined() });
        },
        async sourceCatalog() {
            return (await transport.request({ path: `${BASE}/source-catalog`, schema: catalogSchema })).data;
        },
        async updateScope(input) {
            return (await transport.request({ method: 'PUT', path: `${BASE}/scope`, body: input, schema: statusSchema })).data;
        },
        async issueScimToken() {
            return (await transport.request({ method: 'POST', path: `${BASE}/scim/token`, schema: scimTokenSchema })).data;
        },
        async preview() {
            return (await transport.request({ method: 'POST', path: `${BASE}/preview`, schema: detailSchema })).data;
        },
        async apply(runId, input) {
            return (await transport.request({
                method: 'POST',
                path: `${BASE}/runs/${encodeURIComponent(runId)}/apply`,
                body: input,
                schema: detailSchema,
            })).data;
        },
        async runs(params = {}) {
            return transport.request({
                path: `${BASE}/runs`,
                schema: runsSchema,
                query: { page: params.page, pageSize: params.pageSize },
            });
        },
        async run(runId) {
            return (await transport.request({ path: `${BASE}/runs/${encodeURIComponent(runId)}`, schema: detailSchema })).data;
        },
        async updateSchedule(input) {
            return (await transport.request({ method: 'PATCH', path: `${BASE}/schedule`, body: input, schema: statusSchema })).data;
        },
        async syncNow() {
            return (await transport.request({ method: 'POST', path: `${BASE}/sync-now`, schema: syncNowSchema })).data;
        },
        async approveRun(runId) {
            return (await transport.request({
                method: 'POST',
                path: `${BASE}/runs/${encodeURIComponent(runId)}/approve`,
                schema: detailSchema,
            })).data;
        },
        async discardRun(runId) {
            return (await transport.request({
                method: 'POST',
                path: `${BASE}/runs/${encodeURIComponent(runId)}/discard`,
                schema: detailSchema,
            })).data;
        },
        async setPersonOptOut(personId, input) {
            return (await transport.request({
                method: 'PUT',
                path: `${BASE}/people/${encodeURIComponent(personId)}/opt-out`,
                body: input,
                schema: personSchema,
            })).data;
        },
    };
}
//# sourceMappingURL=directory-sync.js.map